import { useMutation } from "react-query";
import { axiosInstance } from "../../config/axios";

export type CreateSalesmanBonusRequest = {
    year: number;
    month: number;
};

export const createSalesmanBonus = async (data: CreateSalesmanBonusRequest): Promise<any> => {
    const response = await axiosInstance.post(
        "/SalesmanBonus/BonusParameterTermCreate",
        null,
        {
            params: {
                year: data.year,
                month: data.month
            }
        }
    );

    return response.data;
};

export function useCreateSalesmanBonus() {
    return useMutation<any, Error, CreateSalesmanBonusRequest>(
        (variables) => createSalesmanBonus(variables)
    );
}
